module.exports = __webpack_public_path__ + "img/weixin_erweima.a63dc0b7.jpg";